import './FloatingOrbs.css';
import React from 'react';

const FloatingOrbs = () => {
  return (
    <div className="floating-orbs-container">
      <div 
        className="floating-orb floating-orb-1" 
      />
      <div 
        className="floating-orb floating-orb-2" 
      />
      <div 
        className="floating-orb floating-orb-3" 
      />
    </div>
  );
};

export default FloatingOrbs;

